import { render, staticRenderFns } from "./ParaYatirmaSorunlari.vue?vue&type=template&id=4d8a7e48&scoped=true"
import script from "./ParaYatirmaSorunlari.vue?vue&type=script&lang=js"
export * from "./ParaYatirmaSorunlari.vue?vue&type=script&lang=js"
import style0 from "./ParaYatirmaSorunlari.vue?vue&type=style&index=0&id=4d8a7e48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8a7e48",
  null
  
)

export default component.exports